import { AngryIcon, HappyIcon, SedIcon } from "assets"
import { emotionType } from "constant/const"

export const getSentimentIcon = (type) => {
   if (type === emotionType.Positive) {
      return <HappyIcon />
   } else if (type === emotionType.Negative) {
      return <AngryIcon />
   } else if (type === emotionType.Neutral) {
      return <SedIcon />
   } else {
      return null
   }
}
